/** * * Asynchronously loads the component for
PlansAndPricing
* */ import { lazyLoad } from "utils/loadable";
export const PlansAndPricing = lazyLoad(
  () => import("./index"),
  (module) => module.PlansAndPricing
);
